<template>
  <div>
    <h1>Track game</h1>
    <TrackGameForm />
  </div>
</template>

<script>
import TrackGameForm from "@/components/TrackGameForm.vue";

export default {
  name: "TrackGame",
  metaInfo: {
    title: "Track a game",
  },
  components: {
    TrackGameForm,
  },
};
</script>
